export class EntiteModel {
  constructor(
    public id: number = null,
    public code: string = null,
    public libelle: string = null,
    public active: boolean = null,
    public actif: boolean = null,
    public isPrincipale?: boolean,
    public isGerableUtilisateur?: boolean,
    public isEntiteTravail?: boolean,
  ) {}
}
